import React, { Dispatch, SetStateAction, createContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";

type ChangePasswordFormType = {
  newPassword: string,
  confirmNewPassword: string,
}
interface LandingLoginContext {
  setModalChangePasswordState: Dispatch<SetStateAction<boolean>>,
  modalChangePasswordState: boolean,
  setModalRouteToDashboardState: Dispatch<SetStateAction<boolean>>,
  modalRouteToDashboardState: boolean,
  passwordRules: string[],
  changePasswordForm: ChangePasswordFormType,
  setChangePasswordForm: (form: ChangePasswordFormType) => void,
  newPasswordFulfilledRules: number[],
  captchaValue: string,
  setCaptchaValue: (value: string) => void,
}

export const LandingLoginContext = createContext<LandingLoginContext>({
  setModalChangePasswordState: () => undefined,
  modalChangePasswordState: false,
  setModalRouteToDashboardState: () => undefined,
  modalRouteToDashboardState: false,
  passwordRules: [],
  changePasswordForm: {
    newPassword: "",
    confirmNewPassword: "",
  },
  setChangePasswordForm: () => undefined,
  newPasswordFulfilledRules: [],
  captchaValue: null,
  setCaptchaValue: () => undefined,
})

export const LandingLoginProvider = (props: any) => {
  const {
    loginDatas,
  } = useSelector((stateRedux: any) => stateRedux.loginPage);

  const [modalChangePasswordState, setModalChangePasswordState] = useState(false);
  const [modalRouteToDashboardState, setModalRouteToDashboardState] = useState(false);
  const [changePasswordForm, setChangePasswordForm] = useState({
    newPassword: "",
    confirmNewPassword: "",
  })
  const [newPasswordFulfilledRules, setNewPasswordFulfilledRules] = useState([])
  const [captchaValue, setCaptchaValue] = useState(null)

  const patternRequiredCharacters = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/
  const patternNoTagOrPercent = /^[^#%]*$/
  const patternMinimumEightCharacters= /^.{8,}$/
  const patternContainsUsername = new RegExp(`${loginDatas?.data?.user?.pernr}`, 'i')
  const escapedName = loginDatas?.data?.user?.sname?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const patternContainsName = new RegExp(`${escapedName}`, 'i')
  const commonWords = [
    "password",
    "passw0rd",
    "P@ssw0rd",
    "p@ssword",
    "Password",
    "password123",
    "password1",
    "12345678",
    "qwertyui",
    "qwerty123",
    "admin123",
    "adminadmin",
    "abcd1234",
    "abc12345",
    "abcdefg",
  ]
  
  const passwordRules = [
    "Password minimal harus mengandung angka, huruf kecil, dan huruf besar.",
    "Boleh menambahkan karakter khusus seperti ($,@,! dsb) kecuali karakter # dan %.",
    "Panjang password minimal 8 karakter.",
    "Password tidak boleh mengandung atau sama dengan Email.",
    "Password tidak berisi nama akun pengguna atau bagian dari nama lengkap pengguna yang melebihi dua karakter berturut-turut.",
    "Hindari menggunakan kata umum yang sering dipakai.",
  ]

  useEffect(() => {
    if (!modalChangePasswordState) {
      setChangePasswordForm({
        newPassword: "",
        confirmNewPassword: "",
      })
    }
  }, [modalChangePasswordState])
  
  useEffect(() => {
    if (!changePasswordForm.newPassword) {
      setNewPasswordFulfilledRules([])
      return
    } 
    if (patternRequiredCharacters.test(changePasswordForm.newPassword)) {
      addRuleValidated(0)
    } else {
      removeRuleValidated(0)
    }
    if (patternNoTagOrPercent.test(changePasswordForm.newPassword)) {
      addRuleValidated(1)
    } else {
      removeRuleValidated(1)
    }
    if (patternMinimumEightCharacters.test(changePasswordForm.newPassword)) {
      addRuleValidated(2)
    } else {
      removeRuleValidated(2)
    }
    if (!patternContainsUsername.test(changePasswordForm.newPassword)) {
      addRuleValidated(3)
    } else {
      removeRuleValidated(3)
    }
    if (!patternContainsName.test(changePasswordForm.newPassword)) {
      addRuleValidated(4)
    } else {
      removeRuleValidated(4)
    }
    if (!commonWords.some(word => changePasswordForm.newPassword.toLowerCase().includes(word))) {
      addRuleValidated(5)
    } else {
      removeRuleValidated(5)
    }
  }, [changePasswordForm.newPassword])
  
  function addRuleValidated(ruleNumber) {
    if (!newPasswordFulfilledRules.includes(ruleNumber)) {
      setNewPasswordFulfilledRules(prev => {
        return [ ...prev, ruleNumber ]
      })
    }
  }
  function removeRuleValidated(ruleNumber) {
    const index = newPasswordFulfilledRules.indexOf(ruleNumber);
    let newArray = newPasswordFulfilledRules
    if (index !== -1) {
      newArray.splice(index, 1);
      setNewPasswordFulfilledRules([ ...newArray ])
    }
  }

  const contextValue = useMemo<LandingLoginContext>(() => {
    return {
      setModalChangePasswordState,
      modalChangePasswordState,
      setModalRouteToDashboardState,
      modalRouteToDashboardState,
      passwordRules,
      changePasswordForm,
      setChangePasswordForm,
      newPasswordFulfilledRules,
      captchaValue,
      setCaptchaValue,
    }
  }
  , [
    setModalChangePasswordState,
    modalChangePasswordState,
    setModalRouteToDashboardState,
    modalRouteToDashboardState,
    passwordRules,
    changePasswordForm,
    setChangePasswordForm,
    newPasswordFulfilledRules,
    captchaValue,
    setCaptchaValue,
  ])

  return (
    <LandingLoginContext.Provider value={contextValue}>
      {props?.children}
    </LandingLoginContext.Provider>
  );
};
